import ProjectReportSlice from '@rd-web-markets/market/dist/technicalProof/projectReportSlice/ProjectReportSlice';
import React from 'react';
const ProjectReportSliceList = _ref => {
  let {
    handleTinyMce,
    handleSliceChange,
    handleSubmit,
    key,
    index,
    slice,
    report,
    pageAccess
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, report.project_report_slices.filter(slice => slice.tab === 'narrative').filter(slice => slice.title !== 'conclusion').map((slice, index) => /*#__PURE__*/React.createElement(ProjectReportSlice, {
    pageAccess: pageAccess,
    handleTinyMce: handleTinyMce,
    handleSubmit: handleSubmit,
    handleSliceChange: handleSliceChange,
    key: index,
    index: index,
    slice: slice
  })));
};
export default ProjectReportSliceList;